import React from "react";
import s from "./Privacy.module.scss";

export default function Privacy() {
  // ⚠️ Заполни под свою компанию
  const operator = {
    name: "ООО «ДИЗЕЛЬ ГАРАНТ»", // или ИП Фамилия Имя Отчество
    inn: "9707048349",
    ogrn: "1257700265195",
    address: "127055, РОССИЯ, г МОСКВА, пер ТИХВИНСКИЙ, ДОМ 6, офис КВ. 3",
    email: "info@dgarant.ru",
    phone: "+79770906036",
    site: "npskyline.ru",
  };

  return (
    <main className={s.page}>
      <div className={`container ${s.container}`}>
        <header className={s.header}>
          <h1 className={s.title}>Политика обработки персональных данных</h1>
          <p className={s.subtitle}>
            Документ регулирует порядок обработки персональных данных пользователей сайта {operator.site}
            и меры по обеспечению их безопасности.
          </p>
          <div className={s.meta}>
            <span>Редакция: {new Date().toLocaleDateString("ru-RU")}</span>
          </div>
        </header>

        <section className={s.card}>
          <h2>1. Общие положения</h2>
          <p>
            Настоящая Политика определяет порядок и условия обработки персональных данных Пользователей,
            а также меры по обеспечению безопасности персональных данных, предпринимаемые Оператором.
          </p>
          <p>
            Используя сайт и отправляя данные через формы обратной связи, Пользователь подтверждает,
            что ознакомлен с настоящей Политикой и даёт согласие на обработку персональных данных
            в объёме и на условиях, указанных в Политике.
          </p>
        </section>

        <section className={s.card}>
          <h2>2. Оператор персональных данных</h2>
          <ul className={s.list}>
            <li><b>Наименование:</b> {operator.name}</li>
            <li><b>ИНН:</b> {operator.inn}</li>
            <li><b>ОГРН/ОГРНИП:</b> {operator.ogrn}</li>
            <li><b>Адрес:</b> {operator.address}</li>
            <li><b>Email:</b> {operator.email}</li>
            <li><b>Телефон:</b> {operator.phone}</li>
          </ul>
        </section>

        <section className={s.card}>
          <h2>3. Какие данные мы обрабатываем</h2>
          <p>Оператор может обрабатывать следующие категории персональных данных:</p>
          <ul className={s.list}>
            <li>ФИО</li>
            <li>номер телефона</li>
            <li>адрес электронной почты</li>
            <li>текст сообщения/комментария в форме</li>
            <li>технические данные: IP-адрес, дата и время отправки заявки, сведения о браузере (в части, необходимой для защиты и диагностики)</li>
          </ul>
          <p className={s.note}>
            Мы не запрашиваем специальные категории персональных данных (о здоровье, религии и т.п.).
          </p>
        </section>

        <section className={s.card}>
          <h2>4. Цели обработки</h2>
          <ul className={s.list}>
            <li>обработка входящих обращений и заявок</li>
            <li>связь с пользователем для уточнения деталей заявки</li>
            <li>подготовка коммерческого предложения/договора (при необходимости)</li>
            <li>обеспечение работоспособности и безопасности сайта, предотвращение злоупотреблений</li>
          </ul>
        </section>

        <section className={s.card}>
          <h2>5. Правовые основания обработки</h2>
          <p>
            Обработка персональных данных осуществляется на основании согласия Пользователя, выраженного
            путём проставления отметки (галочки) в форме на сайте и отправки заявки.
          </p>
        </section>

        <section className={s.card}>
          <h2>6. Условия обработки и хранение данных</h2>
          <ul className={s.list}>
            <li>Оператор обрабатывает данные с использованием средств автоматизации и без них.</li>
            <li>Срок хранения определяется целями обработки и требованиями законодательства, а также необходимостью защиты прав и законных интересов Оператора.</li>
            <li>После достижения целей обработки данные удаляются или обезличиваются, если иное не требуется законом.</li>
          </ul>
        </section>

        <section className={s.card}>
          <h2>7. Меры защиты персональных данных</h2>
          <ul className={s.list}>
            <li>ограничение доступа к данным и контроль прав</li>
            <li>использование защищённых каналов связи (HTTPS)</li>
            <li>журналирование и мониторинг обращений к сервисам</li>
            <li>меры против спама и злоупотреблений (например, honeypot-поле в форме)</li>
          </ul>
        </section>

        <section className={s.card}>
          <h2>8. Права пользователя</h2>
          <p>Пользователь вправе:</p>
          <ul className={s.list}>
            <li>получить сведения об обработке своих персональных данных</li>
            <li>требовать уточнения, блокирования или удаления данных</li>
            <li>отозвать согласие на обработку персональных данных</li>
          </ul>
        </section>

        <section className={s.card}>
          <h2>9. Отзыв согласия</h2>
          <p>
            Для отзыва согласия пользователь может направить запрос на email: <b>{operator.email}</b>.
            В запросе рекомендуется указать ФИО, контакты и суть требования.
          </p>
        </section>

        <section className={s.card}>
          <h2>10. Cookies и аналитика</h2>
          <p>
            Сайт может использовать cookies и аналогичные технологии для обеспечения работоспособности,
            улучшения качества сервиса и аналитики. Пользователь может ограничить использование cookies
            в настройках браузера.
          </p>
        </section>

        <footer className={s.footer}>
          <div className={s.glowLine} />
        </footer>
      </div>
    </main>
  );
}
